import React, { useCallback } from "react";
import { UploadIcon } from "@heroicons/react/outline";

type Props = {
  iconSrc?: string;
};

const ThumbnailViewer = React.memo(
  ({ iconSrc }: Props) => {

    return (
      <div className="flex flex-col relative">
        <div
          className="w-36 h-36 flex flex-col items-center justify-center cursor-pointer absolute border-solid border-black border-4 rounded-md bg-gray-400 right-10 top-4 bg-full"
          role="button"
          style={{
            backgroundImage: `url(${iconSrc})`,
            backgroundPosition:`center`,
            backgroundSize:`cover`
           }}
          // onClick={onIconClick}
        >
          {!iconSrc && (
            <div className="flex flex-col items-center">
              <UploadIcon className="h-20 w-20 text-gray-600" />
              <span className="text-xs text-black font-semibold">
                THUMBNAIL
              </span>
              <span className="text-xs text-black font-semibold">
                (REQUIRED)
              </span>
            </div>
          )}
        </div>

        <h4 className="font-black text-md md:text-3xl text-left mt-8 mb-4">
          THUMBNAIL IMAGE
        </h4>
      </div>
    );
  }
);

export default ThumbnailViewer;
